var _path, _path2, _path3, _path4, _path5, _g, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFoundSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4514 16.7774C12.4514 25.8606 19.0746 37.0935 27.2571 41.8168C31.5262 44.2844 35.379 44.4812 38.0813 42.816L41.7373 40.7041L40.8365 39.2432C38.3765 40.5527 34.993 40.2878 31.2462 38.123C23.7525 33.7782 17.6818 23.499 17.6818 15.15C17.6818 11.2971 18.9762 8.52675 21.1108 7.08858L20.2024 5.61255L16.5464 7.69412C14.0107 9.208 12.4514 12.3266 12.4514 16.7774Z",
    fill: "url(#paint0_linear_1352_358843)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7952 52.2928C53.7952 52.2928 53.8785 52.9438 52.3646 53.9884C50.8507 55.0329 50.2982 54.8815 50.2982 54.8815L39.6102 40.4089L43.1073 37.8202L53.7952 52.2928Z",
    fill: "url(#paint1_linear_1352_358843)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3672 38.0093C23.8736 33.6872 17.7954 23.408 17.7954 15.059C17.7954 12.1902 18.5144 9.92697 19.7634 8.36011C16.0771 8.93538 13.6398 12.1448 13.6398 17.4433C13.6398 25.7696 19.6953 36.0716 27.2116 40.3937C32.1317 43.2322 36.4387 42.8083 38.8155 39.8184C36.6809 40.1514 34.1149 39.5837 31.3672 37.9942",
    fill: "url(#paint2_linear_1352_358843)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M38.8129 40.5452C44.0805 37.504 44.0808 27.6426 38.8134 18.5193C33.5461 9.39593 25.0057 4.46544 19.7381 7.50671C14.4705 10.548 14.4702 20.4094 19.7376 29.5327C25.005 38.656 33.5453 43.5865 38.8129 40.5452Z",
    fill: "url(#paint3_linear_1352_358843)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6363 59.9226L43.9172 54.3137C44.7499 53.4433 44.7499 52.5274 43.3344 51.7099H43.2966L22.6549 39.7881L22.5868 39.7427C20.6263 38.6149 18.1814 38.9479 16.2134 40.0833C14.2453 41.2187 13.5111 42.7175 15.4564 43.868L36.2192 55.8201C36.8525 56.1578 37.5463 56.3671 38.2608 56.4359C38.9752 56.5047 39.6962 56.4318 40.3824 56.2212L50.2225 61.9058C51.1536 62.4508 54.5825 60.4752 53.6363 59.9226Z",
    fill: "url(#paint4_linear_1352_358843)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M35.3033 41.5972C33.1416 41.5156 31.0386 40.8711 29.2024 39.7276C21.7238 35.413 15.6381 24.8689 15.6381 16.2626C15.6381 12.0464 17.0687 8.89756 19.665 7.39126C22.2613 5.88495 25.7053 6.18016 29.3386 8.30715C36.8399 12.6293 42.9635 23.1734 42.9635 31.81C42.9635 36.0262 41.5329 39.175 38.9366 40.6738C37.8311 41.304 36.5755 41.6231 35.3033 41.5972ZM23.2831 6.75543C22.0795 6.74185 20.8938 7.04742 19.8466 7.64105C17.3487 9.07922 15.9711 12.1297 15.9711 16.2323C15.9711 24.7705 22.0266 35.1557 29.384 39.4551C32.9341 41.5064 36.2646 41.847 38.7625 40.4013C41.2604 38.9555 42.638 35.9051 42.638 31.81C42.638 23.2718 36.6203 12.8866 29.2251 8.57965C27.4368 7.46501 25.3887 6.83623 23.2831 6.75543Z",
    fill: "url(#paint5_linear_1352_358843)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9912 31.5376C45.9912 22.4543 39.368 11.2138 31.1855 6.49812C26.9315 4.0305 23.0787 3.82613 20.3765 5.49139L16.7205 7.59568L17.6212 9.06413C20.0813 7.74706 23.4648 8.01956 27.2116 10.1768C34.7053 14.5065 40.7759 24.7781 40.7759 33.1271C40.7759 36.8059 39.6027 39.4854 37.6649 40.9993C37.5741 41.075 36.7793 41.5518 36.6733 41.62L38.278 42.6948L41.934 40.583C44.4773 39.0615 45.9912 35.9581 45.9912 31.5376Z",
    fill: "url(#paint6_linear_1352_358843)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1352_358843",
    x1: 4.81393,
    y1: -6.54385,
    x2: 35.7575,
    y2: 47.0548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1352_358843",
    x1: 39.6102,
    y1: 46.3509,
    x2: 53.7952,
    y2: 46.3509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1352_358843",
    x1: 14.2756,
    y1: 10.9942,
    x2: 34.2663,
    y2: 45.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1352_358843",
    x1: 29.2719,
    y1: -32.0869,
    x2: 29.2719,
    y2: 77.1996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#787878",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#818181",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C8C8C",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1352_358843",
    x1: 22.829,
    y1: 57.4021,
    x2: 44.8861,
    y2: 44.6704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#565656",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171717",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1352_358843",
    x1: 21.4362,
    y1: 10.4266,
    x2: 40.9652,
    y2: 44.2541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "white",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1352_358843",
    x1: 14.8508,
    y1: -12.3647,
    x2: 45.802,
    y2: 41.2415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundSmall);
export default __webpack_public_path__ + "static/media/not_found_small.b564915cd840d6bf183b156d2c196f91.svg";
export { ForwardRef as ReactComponent };